import { Component } from 'react';

import { /*validateEmail,*/ validatePassword } from '../../../services/utils/form';

class HomePlayInput extends Component {
  constructor(props) {
    super(props);
    let value = '';
    if (props.default_value) {
      value = props.default_value;
    }
    this.state = {
      value: value,
    };

    this.updateForm = this.props.updateForm;
  }

  handleChange(e) {
    const { special_type } = this.props;
    const newValue = e.target.value;
    this.setState({ value: newValue });
    this.updateForm(this.props.input_id, newValue);

    if (special_type && special_type === 'password') {
      this.setState({ password_strength: validatePassword(newValue) });
    }
  }

  render() {
    const { label, input_id, special_type, required } = this.props;
    let { value } = this.state;

    let passwordField = false;
    let passwordIndicatorClass;
    let passwordStrengthText = '';
    let passwordStrengthClass = '';

    let labelClass = 'home_play_input_label';
    let inputClass = 'home_play_input';
    if (this.props.wide) {
      labelClass += ' wide';
      inputClass += ' wide';
    }
    if (this.props.clear) {
      value = '';
      this.setState({ value: '' });
    }
    if (special_type && special_type === 'password') {
      passwordField = true;
      const passwordStrength = validatePassword(value);

      if (passwordStrength === 'strong') {
        passwordStrengthText = 'Strong';
        passwordStrengthClass = 'green';
      } else if (passwordStrength === 'medium') {
        passwordStrengthText = 'Medium';
        passwordStrengthClass = 'yellow';
      } else {
        passwordStrengthText = 'Weak';
        passwordStrengthClass = 'red';
      }
      passwordIndicatorClass = 'password_indicator ' + passwordStrengthClass;
    }

    let type = 'text';
    if (special_type) {
      type = special_type;
    }
    return (
      <div className="home_play_input_container">
        <label className={labelClass}>
          {label}
          {required && (
            <span className="home_play_input_required" title="required field">
              <i className="fa fa-asterisk"></i>
            </span>
          )}
          <input
            input_id={input_id}
            className={inputClass}
            onChange={this.handleChange.bind(this)}
            value={value}
            type={type}
            autoComplete="off"
          ></input>
        </label>
        {value !== '' && passwordField && <div className={passwordIndicatorClass}>{passwordStrengthText}</div>}
      </div>
    );
  }
}

export default HomePlayInput;
